import { NgModule } from '@angular/core';
import { ResizableDirective } from './resizable.directive';
import { ResizeHandleDirective } from './resize-handle.directive';
var ResizableModule = /** @class */ (function () {
    function ResizableModule() {
    }
    ResizableModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [ResizableDirective, ResizeHandleDirective],
                    exports: [ResizableDirective, ResizeHandleDirective]
                },] },
    ];
    /** @nocollapse */
    ResizableModule.ctorParameters = function () { return []; };
    return ResizableModule;
}());
export { ResizableModule };
//# sourceMappingURL=resizable.module.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/angular-resizable-element/dist/esm/src/resizable.module.js
// module id = ../../../../angular-resizable-element/dist/esm/src/resizable.module.js
// module chunks = vendor